import { FC } from 'react';

import { Controller, useFormContext } from 'react-hook-form';

import RhfCheckboxGroup from 'components/CheckboxGroup/RhfCheckboxGroup/RhfCheckboxGroup';
import { If } from 'components/Generics';
import RhfRadioGroup from 'components/RadioGroup/RhfRadioGroup/RhfRadioGroup';
import { RESOLVE_CROWDING_VALUES } from 'constants/prescriptionOptions';
import { getResolveCrowdingConfig } from 'containers/PendingPrescription/pendingPrescriptionConfig';
import { translate } from 'utils';
import { RemoveCheckedOptions } from 'utils/patientpageUtils';
interface Props {
  isLower: boolean;
  fieldName: string;
  isDisabled?: boolean;
}
const ResolveCrowding: FC<Props> = ({ isLower, fieldName, isDisabled }) => {
  const { watch, control } = useFormContext();
  const watchIpr = watch(`${fieldName}.ipr.Ipr`);
  const resolveCrowdingConfig = getResolveCrowdingConfig(isLower);
  return (
    <div className='flex flex-col space-y-2'>
      {resolveCrowdingConfig?.map((item) => {
        let optionFieldName = `${fieldName}.${item?.key}`;
        if (item?.key === 'ipr') {
          optionFieldName = `${fieldName}.ipr.Ipr`;
        }
        return (
          <div key={item?.key} className='flex flex-col '>
            <div className='flex flex-row space-x-4 items-center'>
              <div className='text-14px font-bold mt-2 '>
                {`${translate(item.name)}:`}
              </div>
              <div>
                {item?.isMultiCheck ? (
                  <Controller
                    control={control}
                    name={optionFieldName}
                    render={({ field }) => (
                      <RhfCheckboxGroup
                        disabled={isDisabled}
                        options={item?.options}
                        name={optionFieldName}
                        checkBoxItemFont='md:text-17px text-sm flex flex-row space-x-10'
                        labelClassName='mr-14'
                        onChange={(data, name, e) => {
                          field.onChange(
                            RemoveCheckedOptions(
                              data,
                              RESOLVE_CROWDING_VALUES.NONE,
                              e
                            )
                          );
                        }}
                      />
                    )}
                  />
                ) : (
                  <RhfRadioGroup
                    inputProps={{ disabled: isDisabled }}
                    options={item.options}
                    name={optionFieldName}
                    className='flex flex-row space-x-16'
                    radioClassName='border-RADIO_BORDER'
                    radioItemFont='md:text-17px text-sm '
                  />
                )}
              </div>
            </div>
            <If
              condition={
                !!item?.subOptions &&
                item?.key === 'ipr' &&
                (watchIpr === RESOLVE_CROWDING_VALUES.PRIMARILY ||
                  watchIpr === RESOLVE_CROWDING_VALUES.OPTIONAL)
              }
            >
              <div className='p-4 rounded-2xl bg-CHINESE_WHITE'>
                {item?.subOptions?.map((subOption) => {
                  const subOptionFieldName = `${fieldName}.ipr.${subOption?.key}`;
                  return (
                    <div
                      className='flex flex-row space-x-4 items-center'
                      key={subOption?.key}
                    >
                      <div className='text-14px font-bold mt-2 '>
                        {`${translate(subOption.name)}:`}
                      </div>
                      <div>
                        <RhfRadioGroup
                          inputProps={{ disabled: isDisabled }}
                          options={subOption?.options}
                          name={subOptionFieldName}
                          className='flex flex-row space-x-16'
                          radioClassName='border-RADIO_BORDER'
                          radioItemFont='md:text-17px text-sm '
                        />
                      </div>
                    </div>
                  );
                })}
              </div>
            </If>
          </div>
        );
      })}
    </div>
  );
};
export default ResolveCrowding;
